import { StatusBadge } from "@/components/wheel/StatusBadge";
import { useAuth } from "@/contexts/AuthContext";

export function useCockpitAdmin() {
  const { user } = useAuth();
  return user?.role === "admin";
}

export function CockpitPanel({
  title,
  hint,
  badge,
  onOpenRaw,
  children,
  testid,
  footer,
}) {
  const isAdmin = useCockpitAdmin();
  return (
    <section
      className="border p-3 min-w-0"
      style={{ borderColor: "var(--hoip-border)", background: "var(--hoip-card)" }}
      data-testid={testid}
    >
      <header className="flex items-start justify-between gap-2 mb-2">
        <div className="min-w-0">
          <h2 className="text-[11px] font-bold uppercase tracking-wide" style={{ fontFamily: "Chivo, sans-serif" }}>
            {title}
          </h2>
          {isAdmin && hint ? (
            <p className="text-[10px] mt-0.5 leading-snug" style={{ color: "var(--hoip-text-tertiary)" }} title={hint}>
              {hint}
            </p>
          ) : null}
        </div>
        <div className="flex items-center gap-1.5 shrink-0">
          {isAdmin ? badge : null}
          {isAdmin && typeof onOpenRaw === "function" ? (
            <button
              type="button"
              onClick={onOpenRaw}
              className="text-[10px] underline"
              style={{ color: "var(--hoip-text-tertiary)" }}
              data-testid={testid ? `${testid}-raw` : undefined}
            >
              Raw
            </button>
          ) : null}
        </div>
      </header>
      <div className="min-w-0 overflow-hidden">{children}</div>
      {footer}
    </section>
  );
}

export function MockDataBadge() {
  return (
    <StatusBadge
      tier="info"
      text="Mock series"
      title="Frontend mock. Not a live SentiSense or house-feed payload."
      testid="cockpit-mock-badge"
    />
  );
}
